export enum EntityType {
    Pack = 'Pack',
    RePack = 'Repack',
    Label = 'Label',
    Artist = 'Artist',
}
